import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {socket} from 'context/socket';
import * as Constants from 'context/helper';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Notifications } from 'react-push-notification';
//import {useTranslation} from 'react-i18next';

function SocketNotification() {
	//const {t} = useTranslation('calling');
	const [isPlaying, setIsPlaying] = useState(false);
	const connectedUser = useSelector(({ user }) => user ? user?.user : JSON.parse(localStorage.getItem('current_user')));
	//const state = useSelector(({ chatApp }) => chatApp);

    /*********** Manage sound notification across all app ************/
	
	const [audio] = useState( typeof Audio !== "undefined" && new Audio(`notification_tones/new_msg_tune.mp3`)); 
    //this will prevent rendering errors on NextJS since NodeJs doesn't recognise HTML tags neither its libs.
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const newMessageNotification = async (_msgData) => {
		if(_msgData.muted_users !== undefined && !_msgData.muted_users.includes(connectedUser.id)) {
			setIsPlaying(true)
		}
		let _notifyTxt = await "New message from " + _msgData.messages.senderName;
		Constants.PageTitleNotification.Off();
		Constants.PageTitleNotification.On( _notifyTxt );
	}

	useEffect(() => {
		isPlaying ? setTimeout(()=>{ audio.play() },300) : audio.pause();
		setIsPlaying(false)
	}, [isPlaying, audio]);
	
	useEffect(() => {
		socket.on("new_message_notify", async (data) => {
			// for receiver, if he is not in chat
			var currentStatus = data.chatwith.chatStatus
			currentStatus !== "absent" && newMessageNotification(data)
		})
		socket.on("seen_unread_msg_success", async (_data) => {
			//PageTitleNotification.Off();
		})
	}, [newMessageNotification]);

	/*useEffect(() => {
		socket.on("declinedCallingRequestListener", async (_data) => {
			console.log("declinedCallingRequestListener: ", _data)
			toast.success(t('user_has_declined_call', {username:_data.username}));
		})
	}, []);*/

	function removeFirstWord(str) {
		const indexOfSpace = str.indexOf(' ');
	  
		if (indexOfSpace === -1) {
		  return '';
		}
	  
		return str.substring(indexOfSpace + 1);
	  }

	useEffect(() => {
		socket.on("new_message_notify", async (data) => {
		console.log("new_message_notify: ", data.messages);

			if(data.messages){
				if (Notification['permission'] !== 'granted' && Notification['permission'] !== 'denied')
					Notification.requestPermission();
				else {
					
					/*var notification = data.messages.isGroup ?
															addNotification({
																title: data.messages.senderName + ' in ' + data.messages.groupName,
																icon: 'This is a subtitle',
																message: data.messages.plain_message,
																theme: 'darkblue',
																native: true, // when using native, your OS will handle theming.
																colorTop: 'green',
																props:{
																	position: 'bottom-right',
																},
																duration: 15000,
																backgroundTop: 'green', //optional, background color of top container.
																backgroundBottom: 'darkgreen', //optional, background color of bottom container.
																colorTop: 'green', //optional, font color of top container.
																colorBottom: 'darkgreen', //optional, font color of bottom container.
																closeButton: 'Close', //optional, text or html/jsx element for close text. Default: Close,
															})
											:
															addNotification({
																title: data.messages.senderName,
																icon: "/images/logos/scai.png",
																message: data.messages.plain_message,
																theme: 'darkblue',
																native: true, // when using native, your OS will handle theming.
																colorTop: 'green',
																props:{
																	position: 'bottom-right',
																},
																duration: 15000,
																backgroundTop: 'green', //optional, background color of top container.
																backgroundBottom: 'darkgreen', //optional, background color of bottom container.
																colorTop: 'green', //optional, font color of top container.
																colorBottom: 'darkgreen', //optional, font color of bottom container.
																closeButton: 'Close', //optional, text or html/jsx element for close text. Default: Close,
															})*/
						//let notification = new Notification('To do list', { body: text, icon: img });
						var notification = data.messages.isGroup ? new Notification(data.messages.senderName + ' in ' + data.messages.groupName, {
																	icon: `${process.env.REACT_APP_SERVER_FRONT}/assets/images/logos/scai.png`,
																	body: data.messages.plain_message,
																	})
																:
																new Notification(data.messages.senderName, {
																	icon: localStorage.getItem('iconNotif'),
																	body: data.messages.plain_message,
																	//image: "/assets/images/logos/scai.png", //big image under msg
																	});
					
					 notification.onclick = function(event) {
						 console.log("click notif : ", event, notification)
						window.open(process.env.REACT_APP_SERVER_FRONT+"/chat/messages/"+data.messages.chatId);

					}
					 
				}
			}
		})
		socket.on("mention_notification", async (_data) => {
			console.log("you have been notified in ", _data)

			const Msg = ({ closeToast }) => (
				<div>
				  {_data.messages.senderName} <br />
				  <p>{removeFirstWord(_data.messages.plain_message)}</p>
				</div>
			  )

			toast.success(<Msg />, {
				position: toast.POSITION.BOTTOM_LEFT
			  });

			/*toast.custom((t) => (
				<div
				  className={`${
					t.visible ? 'animate-enter' : 'animate-leave'
				  } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
				>
				  <div className="flex-1 w-0 p-4">
					<div className="flex items-start">
					  <div className="flex-shrink-0 pt-0.5">
						<img
						  className="h-10 w-10 rounded-full"
						  src={_data.messages.groupImage}
						  alt=""
						/>
					  </div>
					  <div className="ml-3 flex-1">
						<p className="text-sm font-medium text-gray-900">
							{_data.messages.senderName}
						</p>
						<p className="mt-1 text-sm text-gray-500">
							{_data.messages.plain_message}
						</p>
					  </div>
					</div>
				  </div>
				  <div className="flex border-l border-gray-200">
					<button
					  onClick={() => toast.dismiss(t.id)}
					  className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
					>
					  Close
					</button>
				  </div>
				</div>
			  ))*/
		})
	}, [])
	
    /*********** End manage sound notification across all app ************/

    return (
        <> 
		<Notifications />
		<ToastContainer
			position="bottom-left"
			autoClose={5000}
			hideProgressBar={false}
			newestOnTop={false}
			closeOnClick
			rtl={false}
			pauseOnFocusLoss
			draggable
			pauseOnHover
			/>
		</>
    )

}

export default SocketNotification;
